import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                { name: 'Layouts', route: 'layouts' },
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
                // { name: 'Quick Links', route: 'quick_links', type: 'quick_link' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            // iconName: '',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'News',
            children: [
                { name: 'Posts', route: 'news_posts', type: 'news_post' },
                { name: 'Categories', route: 'news_categories', type: 'news_category' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Resources',
            children: [
                { name: 'Resources', route: 'resources', type: 'resource' },
                { name: 'Categories', route: 'resource_categories', type: 'resource_category' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'Events',
            route: 'events',
            type: 'events',
            group:'Events',
            iconComponent: FeatherIcons.CalendarIcon,
            color: 'navy',
        },
        {
            name: 'Attendees',
            route: 'event_attendees',
            type: 'event_attendees',
            group:'Events',
            iconComponent: FeatherIcons.UsersIcon,
            color: 'navy',
        },
        {
            name: 'Banners',
            route: 'banners',
            type: 'banner',
            iconClass: 'kt-menu__link-icon flaticon2-chat-2',
            // iconName: '',
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.MessageSquareIcon,
        },

        {
            name: 'Gallery',
            children: [
                { name: 'Gallery', route: 'galleries', type: 'gallery' },
                { name: 'Categories', route: 'gallery_categories', type: 'gallery_category' },
            ],
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.ImageIcon,
        },

        // {
        //     name: 'Products',
        //     children: [
        //         { name: 'Products', route: 'products', type: 'product', _shortcut: 'product/_' },
        //         { name: 'Categories', route: 'categories', type: 'category', _shortcut: 'category/_' },
        //     ],
        //     color: 'navy',
        //     group:'Products',
        //     iconComponent: FeatherIcons.ShoppingCartIcon,
        //     color: 'navy',
        // },
        {
            name: 'Batch Database',
            route: 'hybrid_batches',
            type: 'hybrid_batch',
            color: 'navy',
            group:'Quality Assurance',
            iconComponent: FeatherIcons.CheckSquareIcon,
        },
        {
            name: 'Batch Requests',
            route: 'hybrid_batch_requests',
            type: 'hybrid_batch_request',
            color: 'navy',
            group:'Quality Assurance',
            iconComponent: FeatherIcons.InfoIcon,
        },
        {
            name: 'Hybrids',
            children: [
                { name: 'Canola', route: 'canola_hybrids', type: 'canola_hybrid', _shortcut: 'canola_hybrid/_' },
                { name: 'Corn', route: 'corn_hybrids', type: 'corn_hybrid', _shortcut: 'corn_hybrid/_' },
                { name: 'Sorghum', route: 'sorghum_hybrids', type: 'sorghum_hybrid', _shortcut: 'sorghum_hybrid/_' },
                { name: 'Summer Forage', route: 'summer_forage_hybrids', type: 'summer_forage_hybrid', _shortcut: 'summer_forage_hybrid/_' },
                { name: 'Inoculant', route: 'inoculant_hybrids', type: 'inoculant_hybrid', _shortcut: 'inoculant_hybrid/_' },
                { name: 'Batch Database', route: 'hybrid_batches', type: 'hybrid_batch' },
            ],
            group:'Products',
            iconComponent: FeatherIcons.SlackIcon,
            color: 'navy',
        },
        // {
        //     name: 'Sponsors',
        //     children: [
        //         { name: 'Sponsors', route: 'sponsors', type: 'sponsor' },
        //         { name: 'Categories', route: 'sponsor_categories', type: 'sponsor_category' },
        //     ],
        //     // iconName: '',
        //     color: 'navy',
        //     group: 'media',
        //     iconComponent: FeatherIcons.OctagonIcon,
        // },
          {
            name: 'Team',
            children: [
                { name: 'Team members', route: 'team_member', type: 'team_member' },
                { name: 'Categories', route: 'team_categories', type: 'team_category' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'team',
            iconComponent: FeatherIcons.SmileIcon,
        },
        // {
        //     name: 'Customers',
        //     ...{ name: 'Customers', route: 'customers', type: 'customer' },
        //     // iconName: '',
        //     color: 'navy',
        //     group: 'client',
        //     iconComponent: FeatherIcons.UsersIcon,
        // },
        {
            name: 'Enquiries',
            route: 'enquiries',
            children: [
                { name: 'General Enquiries', route: 'enquiries?filter=team_member_id:$null', type: 'enquiry' },
                { name: 'Sales Rep Enquiries', route: 'enquiries?filter=team_member_id:$not_null', type: 'enquiry' },
            ],
            iconName: '',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.MailIcon,
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users' },
                { name: 'Roles', route: 'roles' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
